import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Map from '../components/Map'


import Header from '../components/Header/Header';
import SideBar from '../components/SideBar/SideBar';
import OfficesContent from '../components/OfficesContent/OfficesContent';
import { getCommonData } from '../components/Main/actions';
import { getOffices } from '../components/OfficesContent/actions';
import { intervalsResetData } from '../components/IntervalsContent/actions'; 
import { toggleStatsModal, } from '../components/Stats/actions';


class OfficesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      centerOfficePos: {
        lat: 50.075172019694584,
        lng: 14.450660048824602 
      },
      centerOfficeId: -1,
    }

    this.handleOnMouseMoveBtnOffice = this.handleOnMouseMoveBtnOffice.bind(this);
    this.inrange = this.inrange.bind(this);
  }

  componentDidMount() {
    document.title = 'Výběr místa';

    if (this.props.officesCommon.status === false) 
      this.props.getCommonData();

    this.props.getOffices();
    this.props.intervalsResetData();

    const openStats = this.props.params.stats;
    if (openStats !== undefined && openStats === 'true') {
      this.props.toggleStatsModal(null);
    }
  }

  handleOnMouseMoveBtnOffice(e, position, officeId) {
    const { centerOfficeId } = this.state;
    
    if ( centerOfficeId !== officeId ) {
      // validate coordinates
      if ( this.inrange(-90, position.lat, 90) && this.inrange(-180, position.lng, 180) ) {
        this.setState({
          centerOfficePos: position,
          centerOfficeId: officeId,
        });
      } else {
        this.setState({
          centerOfficeId: officeId,
        });
      }
    }
  }

  inrange(min, number, max) {
    if ( number != null && !isNaN(number) && (number >= min) && (number <= max) ){
      return true;
    }
    return false;
  }

  render() {
    const { router, officesData, officesCommon, logo, sideBarTitles, } = this.props;
    const { centerOfficePos, centerOfficeId } = this.state; 

    return (
      <div>
        <Header
          logoName={logo.fileName}
          office={null}
        />  

        <SideBar
          activePage={0}
          officeId=''
          serviceId=''
          intervalId=''
          titleOne={sideBarTitles.titleOne}
          titleTwo={sideBarTitles.titleTwo}
          titleThree={sideBarTitles.titleThree}
          titleFour={sideBarTitles.titleFour}
        />    

        <div className="container-fluid page-header page-sidebar">
          <div className="row page-row">
            <div className="col col-md-6 col-sm-12 page-col">
              <OfficesContent 
                officesCommon={officesCommon}
                officesData={officesData}
                handleOnMouseMoveBtnOffice={this.handleOnMouseMoveBtnOffice}
              />
            </div>
            <div className="col col-md-6 page-col page-col-hide-md page-col-left-border page-col-fixed">     
              <Map 
                center={centerOfficePos}
                height="100vh" 
                zoom={13} 
                officeData={officesData} 
              />
            </div>
          </div>
        </div>      
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const { data, status, isLoading, } = state.offices;
  return { 
    officesData: {
      data, 
      status, 
      isLoading,
    },
    officesCommon: {
      status: state.main.status,
      ...state.main.data.officesCommon,
    },
    logo: {
      ...state.main.data.logo,
    },
    sideBarTitles: {
      titleOne: state.main.data.officesCommon.title,
      titleTwo: state.main.data.servicesCommon.title,
      titleThree: state.main.data.intervalsCommon.title,
      titleFour: state.main.data.reservationCommon.title,
    }
  };
}


const mapDispatchToProps = (dispatch) => {
  return {
    getCommonData: bindActionCreators(getCommonData, dispatch),
    getOffices: bindActionCreators(getOffices, dispatch),
    intervalsResetData: bindActionCreators(intervalsResetData, dispatch),
    toggleStatsModal: bindActionCreators(toggleStatsModal, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficesPage);